import { ellipseHiddenText, justifyAlignCenter } from "utils/styles";

export const MenuProps = {
  PaperProps: {
    sx: {
      width: { xs: "250px", sm: "311px" },
      maxHeight: "262px !important",
      marginTop: "8px",
      marginLeft: { xs: "unset", sm: "77px" },
      boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",

      background: "#FFFFFF",
      borderRadius: "unset",

      "& .MuiMenuItem-root": {
        padding: "0px 6px",

        "& .MuiTypography-root": ellipseHiddenText,
      },

      "& .Mui-checked": {
        color: "#2196F3",
      },
    },
  },
};

export const selectCompStyles = {
  background: "#F5F5F5",
  borderRadius: "58px",
  height: "fit-content",

  "& .MuiOutlinedInput-input": {
    background: "none",
    p: "11px 67.9px 11px 14.88px",
  },
  "& .MuiSvgIcon-root": {
    color: "#212121",
  },
  "& .Mui-disabled": {
    borderRadius: "58px",
    background: "#E2E2E2",
  },
};

export const filterBoxStyle = {
  p: "12px 17px",
  position: "sticky",
  bottom: 0,
  background: "white",
};

export const filterListStyle = { width: "100%", p: "4px 17px 0" };

export const filterNoData = { ...justifyAlignCenter, p: "20px 0" };
